<template>
    <div class="settings">
        <div class="settings-content">
            <template v-if="role == 'admin'">
                <h1>{{ $t('setting', 0) }}</h1>
                <label>
                    <div class="label">{{ $t('name') }}</div>
                    <input type="text" v-model="newName" @keydown="setName">
                </label>

                <label>
                    <div class="label">Explicação</div>
                    <textarea type="text" v-model="newSettingExplanation" @keydown="setSettingExplanation" />
                </label>

                <label>
                    <input type="file" @change="newLogoUpload">
                    <div class="label">Logotipo</div>
                </label>

                <label>
                    <div class="label">Assunto do email de convite a <strong>{{ $t('worker', 0) }}</strong></div>
                    <input type="text" v-model="inviteWorkerSubject" @keydown="saveWorkerInviteEmail">
                </label>

                <label>
                    <div class="label">Corpo do email de convite a <strong>{{ $t('worker', 0) }}</strong></div>
                    <textarea type="text" v-model="inviteWorkerBody" @keydown="saveWorkerInviteEmail" />
                </label>

                <label>
                    <div class="label">Assunto do email de convite a <strong>{{ $t('consumer', 0) }}</strong></div>
                    <input type="text" v-model="inviteConsumerSubject" @keydown="saveConsumerInviteEmail">
                </label>

                <label>
                    <div class="label">Corpo do email de convite a <strong>{{ $t('consumer', 0) }}</strong></div>
                    <textarea type="text" v-model="inviteConsumerBody" @keydown="saveConsumerInviteEmail" />
                </label>

                <hr>
            </template>

            <h1>Perfil</h1>
            <label for="image-upload">
                <input type="file" id="image-upload" name="profileImage" ref="imageInput" @change="handleImageUpload">
                <div class="label">Imagem de Perfil</div>
            </label>
            <div>
                <p>Imagem Escolhida</p>
                <div>
                    <img v-if="!hideImage" :src="imageAPI">
                </div>
                <p class="errorMessage" v-text="chooseImage"></p>
                <button v-if="isImageUploaded" @click="uploadImage">Submeter</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SettingsPage',

    data() {
        return {
            image: null,
            chooseImage: null,
            imageUploaded: null,
            selectedImage: 'Escolher a Imagem',
            hideImage: false,
            imageAPI: null,
            logoToUpload: null,
            setNameTimeout: null,
            newName: "",
            newSettingExplanation: "",

            inviteConsumerSubject: "",
            inviteConsumerBody: "",
            saveConsumerInviteTimeout: null,

            inviteWorkerSubject: "",
            inviteWorkerBody: "",
            saveWorkerInviteTimeout: null,
        }
    },
    methods: {
        saveConsumerInviteEmail() {
            clearTimeout(this.saveConsumerInviteTimeout)
            this.saveConsumerInviteTimeout = setTimeout(() => {
                this.$store.dispatch('instance/saveConsumerInviteEmail', {
                    subject: this.inviteConsumerSubject,
                    body: this.inviteConsumerBody,
                })
            }, 400)
        },
        saveWorkerInviteEmail() {
            clearTimeout(this.saveWorkerInviteTimeout)
            this.saveWorkerInviteTimeout = setTimeout(() => {
                this.$store.dispatch('instance/saveWorkerInviteEmail', {
                    subject: this.inviteWorkerSubject,
                    body: this.inviteWorkerBody,
                })
            }, 400)
        },
        setName() {
            clearTimeout(this.setNameTimeout)
            this.setNameTimeout = setTimeout(() => {
                this.$store.dispatch('instance/setName', this.newName)
            }, 400)
        },
        setSettingExplanation() {
            clearTimeout(this.setSettingExplanationTimeout)
            this.setSettingExplanationTimeout = setTimeout(() => {
                this.$store.dispatch('instance/setSettingExplanation', this.newSettingExplanation)
            }, 400)
        },
        newLogoUpload(e) {
            this.logoToUpload = e.target.files[0]
            this.$store.dispatch('instance/uploadLogo', this.logoToUpload)
        },
        handleImageUpload(event) {
            this.image = event.target.files[0]
            if (this.image) {
                this.selectedImage = this.image.name;
            }
        },

        async uploadImage() {
            if (!this.image) {
                this.chooseImage = "Por favor, escolha uma imagem"
            }

            this.$store.dispatch('profiles/update', { image: this.image, name: this.currentUser.displayName })
        },
    },

    computed: {
        currentUser() {
            return this.$store.state.users.currentUser
        },
        instance() {
            return this.$store.state.instance.data
        },
        role() {
            return this.$store.state.users.role
        },
        name() {
            return this.$store.state.instance.name
        },
        isImageUploaded() {
            return this.image;
        },
        previewSrc() {
            return URL.createObjectURL(this.logoToUpload)
        },
    },

    watch: {
        name: {
            immediate: true,
            handler() {
                if (this.name == null) {
                    return
                }
                if (this.newName == this.name) {
                    return
                }
                this.newName = this.name
                if (this.instance.consumerInviteEmail != null) {
                    this.inviteConsumerSubject = this.instance.consumerInviteEmail.subject
                    this.inviteConsumerBody = this.instance.consumerInviteEmail.body
                }
                if (this.instance.workerInviteEmail != null) {
                    this.inviteWorkerSubject = this.instance.workerInviteEmail.subject
                    this.inviteWorkerBody = this.instance.workerInviteEmail.body
                }
            }
        },
        instance: {
            immediate: true,
            handler() {
                if (this.instance.settingExplanation != null) {
                    this.newSettingExplanation = this.instance.settingExplanation
                }
            },
        },
    },

    mounted() {
    },
}
</script>

<style lang="scss" scoped>
@import '@/assets/utilities/_variables.scss';

.settings {
    margin: 1rem 2rem;
    width: -webkit-fill-available;

    h1 {
        text-transform: capitalize;
    }

    label {
        input[type=file] {
            display: none;

            &+.label {
                padding: 1rem;
                border: 2px dashed;
                border-radius: 10px;
                width: fit-content;
            }
        }

        input,
        textarea {
            outline: none;
            padding: .5rem;
            width: 100%;
            background-color: var(--bg-color-2);
            border: 2px solid var(--bg-color-2);
            color: var(--text-color);
            border-radius: 5px;

            &:focus {
                border: 2px solid var(--highlight-color);
                box-shadow: 0 0 0 1px var(--highlight-color), inset 0 0 0 1px var(--highlight-color);
            }
        }

        textarea {
            height: 300px;
        }

        img {
            max-width: 50px;
            max-height: 50px;
        }
    }

    &-content {
        background: var(--sidebar-bg-color);
        border-radius: 10px;
        padding: 1rem;
    }
}
</style>
